export default __webpack_public_path__ + "static/media/product_craftx_5x.44f91c01.png";